import posed from 'react-pose';

export const RouteContainer = posed.div({
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      x: { ease: 'easeOut', duration: 300 },
      opacity: { ease: 'easeOut', duration: 300 }
    },
  },
  exit: {
    x: '-100vw',
    opacity: 0,
    transition: {
      x: { ease: 'easeOut', duration: 300 },
      opacity: { ease: 'easeOut', duration: 300 }
    },
  },
});
